import { useEffect, useRef } from "react";
import { wsUrl, getToken } from "./api";

export function useWebSocket(onEvent) {
  const ref = useRef(onEvent);
  ref.current = onEvent;
  useEffect(() => {
    if (!getToken()) return;
    let ws;
    let stopped = false;
    let retry;
    function connect() {
      try {
        ws = new WebSocket(wsUrl());
      } catch {
        return;
      }
      ws.onmessage = (e) => {
        try {
          ref.current(JSON.parse(e.data));
        } catch {}
      };
      ws.onclose = () => {
        if (!stopped) retry = setTimeout(connect, 2000);
      };
      ws.onerror = () => {
        try { ws.close(); } catch {}
      };
    }
    connect();
    return () => {
      stopped = true;
      clearTimeout(retry);
      if (ws) try { ws.close(); } catch {}
    };
  }, []);
}
